import { defineMessages } from 'react-intl';

const messages = defineMessages({
  actions: {
    id: 'features.notificationsCenter.actions',
    defaultMessage: 'Actions',
  },
  deleteNotification: {
    id: 'features.notificationsCenter.deleteNotification',
    defaultMessage: 'Delete notification',
  },
  nothingToDisplay: {
    id: 'features.notificationsCenter.nothingToDisplay',
    defaultMessage: 'Nothing to display',
  },
  notificationCenter: {
    id: 'features.notificationsCenter.notificationCenter',
    defaultMessage: 'Notification Center',
  },
  notifications: {
    id: 'features.notificationsCenter.notifications',
    defaultMessage: 'Notifications',
  },
  uploads: {
    id: 'features.notificationsCenter.uploads',
    defaultMessage: 'Uploads',
  },
});

export default messages;
